(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .directive('tfcPage', tfcPage);

  // @ngInject
  function tfcPage() {
    return {
      templateUrl : 'Nav/Page.tmpl.html',
      scope : {
        fullWidth : '='
      }
    };
  }

})();
